import React from "react";
import { useParams } from "react-router-dom";

// Import all location components
import GurajadaKalakshetram from "./locations/GurajadaKalakshetram";
import MGMLAWN from "./locations/MGMLAWN";

import ChildrensArena from "./locations/ChildrensArena";
import InsKurusuraSubmarineLawn from "./locations/InsKurusuraSubmarineLawn";
import CentralParkAmphiTheatre from "./locations/CentralParkAmphiTheatre";
import KailasagiriLawn1 from "./locations/KailasagiriLawn1";
import KailasagiriLawn2 from "./locations/KailasagiriLawn2";
import ViswapriyaFunctionHall from "./locations/ViswapriyaFunctionHall";
import VMRDALandWaltairUplands from "./locations/VMRDALandWaltairUplands";
import ThatichetlapalemKalyanamandapam from "./locations/ThatichetlapalemKalyanamandapam";
import ChinamushidiwadaKalyanamandapam from "./locations/ChinamushidiwadaKalyanamandapam";
import RaoGopalRaoAuditorium from "./locations/RaoGopalRaoAuditorium";
import ThotlakondaPark from "./locations/ThotlakondaPark";
import Chemalapalli from "./locations/Chemalapalli";
import Yendada from "./locations/Yendada"; // Assuming this is the correct import for Yendada
import MadhavaDwara from "./locations/MadhavaDwara";
// Mapping location IDs to components
const locationComponents = {
  1: GurajadaKalakshetram,
  2: MGMLAWN,
  4: ChildrensArena,
  5: ThotlakondaPark,
  6: InsKurusuraSubmarineLawn,
  7: CentralParkAmphiTheatre,
  8: KailasagiriLawn1,
  9: KailasagiriLawn2,
  10: ViswapriyaFunctionHall,
  11: VMRDALandWaltairUplands,
  12: ThatichetlapalemKalyanamandapam,
  13: ChinamushidiwadaKalyanamandapam,
  14: RaoGopalRaoAuditorium,
  15: Yendada, // Assuming this is the correct ID for Yendada
  16: Chemalapalli, // Assuming this is the correct ID for InsKurusuraSubmarineLawn
  17: MadhavaDwara,
};

const LocationHandler = () => {
  const { id } = useParams();
  const LocationComponent = locationComponents[id] || GurajadaKalakshetram; // Default fallback

  return <LocationComponent />;
};

export default LocationHandler;
